export default __webpack_public_path__ + "static/media/1988.4ff07dcd.png";